import React from "react";
const reports = () => {
  return <div>Reports</div>;
};

export default reports;
